import type { PropsWithChildren } from "react";
import { useEffect, useState } from "react";
import { getUser } from "../actions/auth";
import { AppRedirect } from "../components/app/LegacyRouteRedirect";
import { hasPermission } from "../helpers/permissions";
import type { RoutePermission } from "./routeManifest";

interface PermissionBoundaryProps extends PropsWithChildren {
  permission?: RoutePermission;
}

export default function PermissionBoundary({ children, permission }: PermissionBoundaryProps) {
  const [, rerender] = useState(0);

  useEffect(() => {
    const handleUserUpdate = () => rerender((version) => version + 1);
    document.addEventListener("asset:update-user", handleUserUpdate);
    return () => document.removeEventListener("asset:update-user", handleUserUpdate);
  }, []);

  const user = getUser();
  if (!user) return <AppRedirect to="/signin" />;
  if (permission && !hasPermission(permission.resource, permission.action, user)) {
    return <AppRedirect to="/not-authorized" />;
  }

  return children;
}
